export default {
  black: '#000000',
  white: '#FFFFFF',
  gray100: '#F8F8F8',
  gray200: '#E4E4E4',
  gray300: '#D7D6D6',
  gray400: '#C4C4C4',
  gray500: '#C3C6CB',
  gray600: '#9B9B9B',
  gray700: '#979797',
  gray800: '#747576',
  gray900: '#3e3e3e',
  green: '#05b28e',
  red: '#FA2E2E',
  cyanDark: '#04E3FF',
  cyan: '#04E2FF',
  blue: '#2787FF',
  navy: '#3856FF',
  ocean: '#17B4FF',
  purple: '#4E19FF',
};
